var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _circle3, _circle4, _circle5, _circle6, _circle7, _path7, _g, _g2, _g3, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 305,
    viewBox: "0 0 393 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.778 238.643L335.644 181.287C363.022 140.057 366.044 102.676 337.422 77.1526C304.889 58.5137 293.511 85.2673 260.089 74.8224C235.2 112.693 181.191 192.025 164.267 206.392C156.139 213.291 155.002 222.822 157.793 232.596C64.9669 235.73 195.904 291.333 234.667 267.229C247.111 257.7 257.778 238.643 257.778 238.643Z",
    fill: "#006C9C",
    stroke: "#006C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1556 96.262C93.44 94.2097 113.778 57.6586 123.911 39.6396C134.044 21.6205 146.221 13.6539 165.689 7.57182C195.13 -1.62631 223.323 2.08753 242.133 27.179C256.98 46.983 239.141 68.8586 251.2 90.5815C270.918 126.1 310.157 111.758 344.356 132.544C364.329 144.685 373.013 156.648 373.735 167.911C386.628 369.113 259.914 244.631 217.067 236.81C217.067 236.81 197.131 246.473 185.778 254.952C163.556 285.92 162.667 320.003 103.822 293.433C85.1556 278.04 93.1556 246.156 93.1556 246.156C93.037 197.046 92.8711 98.3144 93.1556 96.262Z",
    stroke: "#006C9C",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.978 27.179C230.377 12.1915 198.578 14.3518 186.133 36.1579C162.002 78.4432 156.427 79.4683 112.178 71.6702C71.8788 64.5682 15.5978 68.4897 25.0319 157.282C27.7333 204.376 26.3111 205.659 40.1778 227.132C64.516 259.357 114.489 253.852 138.845 251.47C171.347 250.455 186.133 220.685 218.133 225.266C261.689 225.266 275.022 277.674 319.289 257.517C383.111 226.915 368 150.136 319.289 135.451C240.711 86.9166 296.669 56.1531 252.978 27.179Z",
    fill: "#1AD879",
    stroke: "#1AD879"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M316.8 79.9533C316.8 79.9533 303.289 43.3044 305.067 42.0217C306.844 40.739 330.844 75.3646 348.267 77.6589C365.689 79.9533 374.4 70.1091 381.156 71.7073C387.911 73.3054 392.777 85.2673 391.284 94.7961C389.791 104.325 374.756 109.822 351.289 109.822C327.822 109.822 316.8 79.9533 316.8 79.9533Z",
    fill: "#1AD879"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M285.156 138.591L306.844 134.743M305.067 42.0217C303.289 43.3044 316.8 79.9533 316.8 79.9533C316.8 79.9533 327.822 109.822 351.289 109.822C374.756 109.822 389.791 104.325 391.284 94.7961C392.777 85.2673 387.911 73.3054 381.156 71.7073C374.4 70.1091 365.689 79.9533 348.267 77.6589C330.844 75.3646 306.844 40.739 305.067 42.0217Z",
    stroke: "#1AD879"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M212.622 26.7428C217.72 26.7428 221.854 30.8758 221.854 35.9742C221.854 41.0729 217.72 45.2067 212.622 45.2067C207.523 45.2064 203.39 41.0727 203.39 35.9742C203.391 30.876 207.523 26.743 212.622 26.7428Z",
    stroke: "#00B8D9",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 227.378,
    cy: 266.679,
    r: 22.5613,
    fill: "#119F66"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.378,
    cy: 36.1579,
    r: 22.5613,
    fill: "#119F66"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 171.446,
    y: 13.335,
    width: 2.70735,
    height: 10.8294,
    fill: "#C6F6FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 167.385,
    y: 20.1034,
    width: 2.70735,
    height: 10.8294,
    transform: "rotate(-90 167.385 20.1034)",
    fill: "#C6F6FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 186.33,
    y: 284.288,
    width: 2.70735,
    height: 10.8294,
    transform: "rotate(1.6379 186.33 284.288)",
    fill: "#C6F6FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 182.077,
    y: 290.938,
    width: 2.70735,
    height: 10.8294,
    transform: "rotate(-88.3621 182.077 290.938)",
    fill: "#C6F6FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80.7742,
    y: 45.2416,
    width: 3.42932,
    height: 13.7173,
    fill: "#C6F6FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 75.6302,
    y: 53.8148,
    width: 3.42932,
    height: 13.7173,
    transform: "rotate(-90 75.6302 53.8148)",
    fill: "#C6F6FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.14398,
    y: 186.34,
    width: 3.42932,
    height: 13.7173,
    fill: "#C6F6FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 194.913,
    width: 3.42932,
    height: 13.7173,
    transform: "rotate(-90 0 194.913)",
    fill: "#C6F6FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 282.072,
    y: 29.0803,
    width: 2.25613,
    height: 9.02452,
    fill: "#C6F6FF"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 278.688,
    y: 34.7206,
    width: 2.25613,
    height: 9.02452,
    transform: "rotate(-90 278.688 34.7206)",
    fill: "#C6F6FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.6,
    cy: 48.8018,
    r: 7.21961,
    fill: "#66CAF5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.7111,
    cy: 251.836,
    r: 9.02452,
    fill: "#8CFDB2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.933,
    cy: 288.119,
    r: 8.32942,
    stroke: "#66CAF5",
    strokeWidth: 5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.978,
    cy: 124.848,
    r: 6.31716,
    fill: "#8CFDB2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5123,
    cy: 262.512,
    r: 4.51226,
    fill: "#66CAF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7347 131.076L68.532 76.655M7.16874 154.683L59.9661 100.263",
    stroke: "#006C9C",
    strokeWidth: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.7303 224.803C83.2832 225.697 79.0735 231.509 77.0245 234.303L71.4364 230.391L56.3485 213.627C65.8483 213.813 84.9596 214.186 85.4067 214.186C85.9655 214.186 84.2891 223.685 83.7303 224.803Z",
    fill: "#006C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7752 236.873L77.6091 235.941C83.0641 229.848 86.3692 221.957 86.9138 213.721L87 212.422H53.0369L76.7752 236.873ZM68.1072 214.855H75.1946H82.2821H84.4473C84.1816 217.4 83.6335 219.901 82.8255 222.308C82.6613 222.22 82.4817 222.155 82.2833 222.155C81.6312 222.155 81.102 222.7 81.102 223.372C81.102 223.936 81.4824 224.39 81.9892 224.528C80.6733 227.709 78.8931 230.691 76.6913 233.345L75.2643 231.875C75.8821 231.836 76.3759 231.319 76.3759 230.672C76.3759 230 75.8467 229.455 75.1946 229.455C74.5662 229.455 74.0642 229.964 74.0276 230.601L71.7206 228.224C72.3384 228.186 72.8322 227.669 72.8322 227.022C72.8322 226.35 72.303 225.805 71.6509 225.805C71.0225 225.805 70.5216 226.314 70.4838 226.951L68.1769 224.575C68.7947 224.535 69.2884 224.019 69.2884 223.372C69.2884 222.7 68.7592 222.155 68.1072 222.155C67.4788 222.155 66.9779 222.664 66.9401 223.301L64.6331 220.925C65.2509 220.885 65.7447 220.369 65.7447 219.722C65.7447 219.05 65.2155 218.505 64.5634 218.505C63.935 218.505 63.4342 219.014 63.3964 219.651L61.0894 217.275C61.7072 217.235 62.201 216.719 62.201 216.072C62.201 215.4 61.6718 214.855 61.0197 214.855C60.3913 214.855 59.8904 215.364 59.8526 216.001L58.7411 214.855H61.0197H68.1072Z",
    fill: "#006C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4951 225.362C79.8289 228.53 75.9069 232.626 75.9069 232.626L59.2449 215.409L58.5838 214.744H63.0543C70.865 217.348 84.4312 213.299 83.0353 221.405C83.1715 222.009 81.8813 224.976 81.4951 225.362Z",
    fill: "#006C9C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8149 214.251L68.6014 236.526L60.8327 241.717L42.9857 242.798L31.2277 237.175L21.1495 223.983L18.8398 206.466L23.879 193.49L35.847 183.325L47.8149 180.298V214.251Z",
    fill: "#039FDD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.6509 179L47.5221 179.078C30.9674 180.242 18 194.549 18 211.653C18 229.661 32.2241 244.312 49.7078 244.312C57.0291 244.312 64.1739 241.672 69.8285 236.881L70.7279 236.119L48.6509 213.379V179ZM67.5688 235.945C62.448 239.944 56.1508 242.135 49.7078 242.135C33.3899 242.135 20.1139 228.46 20.1139 211.653C20.1139 196.081 31.6301 182.992 46.537 181.353V214.281L67.5688 235.945Z",
    fill: "#039FDD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 175L53.7226 208H86V204.36L79.2555 188.588L68.1752 179.368L53 175Z",
    fill: "#8CFDB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9144 207.711C85.7265 189.767 71.6851 175.311 54.2524 174.087L53 174V209H87L86.9144 207.711ZM55.3453 206.586V176.609C58.216 176.925 60.9799 177.627 63.5844 178.663C63.5774 178.718 63.5539 178.766 63.5539 178.821C63.5539 179.488 64.0793 180.028 64.7266 180.028C65.0924 180.028 65.4067 179.845 65.6213 179.575C72.635 182.944 78.3118 188.788 81.5847 196.007C81.322 196.23 81.1438 196.552 81.1438 196.929C81.1438 197.595 81.6691 198.136 82.3164 198.136C82.3704 198.136 82.4173 198.112 82.47 198.104C83.4762 200.787 84.1587 203.631 84.4659 206.586H55.3453Z",
    fill: "#8CFDB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 178.5C63 178.5 65 179 66.5 180C66.4731 181.104 64.5 182 64.5 182L62.5 181L63 178.5Z",
    fill: "#8CFDB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 195C81 195 83 198 82.5 199C81.7886 199.697 80 199.5 80 199.5C79.8333 199.167 79.5 198.4 79.5 198C79.5 197.6 80.5 195.833 81 195Z",
    fill: "#8CFDB2"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_9_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301 226.938V244.981C301 245.401 303.106 245.742 305.702 245.742C308.299 245.742 310.403 245.401 310.403 244.981V226.938C310.403 226.518 308.297 226.177 305.702 226.177C303.106 226.177 301 226.518 301 226.938Z",
    fill: "url(#paint0_linear_9_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.15 226.942C301.153 226.937 301.162 226.924 301.188 226.903C301.234 226.867 301.31 226.825 301.423 226.782C301.647 226.696 301.98 226.617 302.401 226.548C303.242 226.412 304.409 226.328 305.701 226.328C306.994 226.328 308.161 226.412 309.002 226.548C309.424 226.617 309.757 226.696 309.98 226.782C310.093 226.825 310.169 226.867 310.215 226.903C310.241 226.924 310.25 226.937 310.253 226.942V244.977C310.25 244.982 310.241 244.995 310.215 245.016C310.169 245.052 310.093 245.094 309.98 245.137C309.757 245.223 309.424 245.302 309.003 245.371C308.162 245.507 306.995 245.591 305.701 245.591C304.409 245.591 303.242 245.507 302.401 245.371C301.98 245.302 301.647 245.223 301.423 245.137C301.31 245.094 301.234 245.053 301.188 245.017C301.162 244.996 301.153 244.982 301.15 244.977V226.942Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_9_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.403 213.894V244.981C313.403 245.401 315.509 245.742 318.105 245.742C320.703 245.742 322.807 245.401 322.807 244.981V213.894C322.807 213.473 320.701 213.133 318.105 213.133C315.509 213.133 313.403 213.474 313.403 213.894Z",
    fill: "url(#paint1_linear_9_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.554 213.898C313.556 213.893 313.564 213.879 313.592 213.858C313.637 213.822 313.714 213.781 313.826 213.738C314.05 213.652 314.383 213.572 314.805 213.503C315.645 213.367 316.812 213.283 318.104 213.283C319.397 213.283 320.564 213.367 321.405 213.503C321.827 213.572 322.16 213.652 322.384 213.738C322.496 213.781 322.573 213.822 322.618 213.858C322.646 213.88 322.654 213.893 322.656 213.898V244.977C322.654 244.982 322.645 244.995 322.618 245.016C322.573 245.052 322.496 245.094 322.384 245.137C322.16 245.223 321.828 245.302 321.406 245.371C320.566 245.507 319.398 245.591 318.104 245.591C316.812 245.591 315.645 245.507 314.805 245.371C314.383 245.302 314.05 245.223 313.826 245.137C313.714 245.094 313.637 245.053 313.592 245.017C313.565 244.996 313.556 244.982 313.554 244.977V213.898Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_9_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.807 204.11V244.981C325.807 245.401 327.912 245.742 330.508 245.742C333.106 245.742 335.21 245.401 335.21 244.981V204.11C335.21 203.69 333.104 203.349 330.508 203.349C327.912 203.349 325.807 203.69 325.807 204.11Z",
    fill: "url(#paint2_linear_9_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.957 204.114C325.959 204.109 325.968 204.095 325.995 204.074C326.04 204.038 326.117 203.997 326.229 203.954C326.453 203.868 326.786 203.788 327.208 203.72C328.049 203.584 329.216 203.499 330.508 203.5C331.8 203.5 332.968 203.584 333.808 203.72C334.23 203.788 334.563 203.868 334.787 203.954C334.9 203.997 334.976 204.039 335.021 204.075C335.048 204.096 335.057 204.109 335.059 204.114V244.977C335.057 244.982 335.048 244.995 335.021 245.016C334.976 245.052 334.9 245.094 334.787 245.137C334.563 245.223 334.231 245.302 333.809 245.371C332.969 245.507 331.801 245.591 330.508 245.591C329.216 245.591 328.049 245.507 327.208 245.371C326.786 245.302 326.453 245.223 326.229 245.137C326.117 245.094 326.04 245.053 325.995 245.017C325.968 244.996 325.96 244.982 325.957 244.977V204.114Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_9_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.21 193.022V244.981C338.21 245.401 340.316 245.742 342.911 245.742C345.509 245.742 347.613 245.401 347.613 244.981V193.022C347.613 192.601 345.507 192.261 342.911 192.261C340.316 192.261 338.21 192.602 338.21 193.022Z",
    fill: "url(#paint3_linear_9_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.36 193.026C338.363 193.021 338.371 193.007 338.398 192.986C338.444 192.95 338.52 192.909 338.633 192.866C338.857 192.78 339.19 192.701 339.611 192.632C340.452 192.496 341.619 192.411 342.911 192.411C344.203 192.411 345.371 192.495 346.212 192.631C346.633 192.7 346.966 192.78 347.19 192.866C347.303 192.909 347.379 192.95 347.425 192.986C347.452 193.007 347.46 193.021 347.463 193.026V244.977C347.46 244.982 347.451 244.995 347.425 245.016C347.379 245.052 347.303 245.094 347.19 245.137C346.967 245.223 346.634 245.302 346.213 245.371C345.372 245.507 344.204 245.591 342.911 245.591C341.619 245.591 340.452 245.507 339.611 245.371C339.19 245.302 338.857 245.223 338.633 245.137C338.52 245.094 338.444 245.053 338.398 245.017C338.372 244.996 338.363 244.982 338.36 244.977V193.026Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.3
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_9_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.613 189.761V244.981C350.613 245.401 352.719 245.742 355.315 245.742C357.913 245.742 360.016 245.401 360.016 244.981V189.761C360.016 189.34 357.91 189 355.315 189C352.719 189 350.613 189.34 350.613 189.761Z",
    fill: "url(#paint4_linear_9_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.764 189.764C350.766 189.759 350.776 189.746 350.802 189.725C350.847 189.689 350.924 189.648 351.036 189.605C351.26 189.519 351.593 189.439 352.015 189.371C352.855 189.235 354.022 189.15 355.314 189.15C356.607 189.15 357.774 189.235 358.615 189.371C359.037 189.439 359.37 189.519 359.594 189.605C359.706 189.648 359.783 189.689 359.828 189.725C359.855 189.747 359.864 189.76 359.866 189.765V244.977C359.863 244.982 359.855 244.995 359.828 245.016C359.783 245.052 359.706 245.094 359.594 245.137C359.37 245.223 359.037 245.302 358.616 245.371C357.775 245.507 356.608 245.591 355.314 245.591C354.022 245.591 352.855 245.507 352.015 245.371C351.593 245.302 351.26 245.223 351.036 245.137C350.924 245.094 350.847 245.053 350.802 245.017C350.775 244.996 350.766 244.982 350.764 244.977V189.764Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9_3",
    x: 49.0369,
    y: 212.422,
    width: 41.9631,
    height: 32.4518,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9_3",
    x: 14.8398,
    y: 180.298,
    width: 57.7615,
    height: 70.5005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9_3",
    x: 49,
    y: 174,
    width: 42,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_9_3",
    x: 297,
    y: 226.177,
    width: 17.4033,
    height: 27.5643,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_9_3",
    x: 309.403,
    y: 213.133,
    width: 17.4033,
    height: 40.6088,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_9_3",
    x: 321.807,
    y: 203.349,
    width: 17.4033,
    height: 50.3925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_9_3",
    x: 334.21,
    y: 192.261,
    width: 17.4033,
    height: 61.4808,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_9_3",
    x: 346.613,
    y: 189,
    width: 17.4033,
    height: 64.7418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_3",
    x1: 305.702,
    y1: 202.045,
    x2: 305.702,
    y2: 251.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_3",
    x1: 318.107,
    y1: 202.045,
    x2: 318.107,
    y2: 251.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_3",
    x1: 330.508,
    y1: 202.045,
    x2: 330.508,
    y2: 251.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9_3",
    x1: 342.913,
    y1: 203.587,
    x2: 342.913,
    y2: 251.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9_3",
    x1: 355.316,
    y1: 203.501,
    x2: 355.316,
    y2: 251.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006C9C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 76,
    fill: "white",
    transform: "translate(14 173)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeBackground);
export default __webpack_public_path__ + "static/media/welcomeBackground.9f48ec938ba3896f8ea2935c7a236ce2.svg";
export { ForwardRef as ReactComponent };